import uni from "../styles/univesal.module.css";
import { header, error, checkbox, logo } from "./common";
import { LangIds, Languages, getLang } from "../langs/langs";
import { Check } from "../types";
import Lottie from "lottie-react";
import lottie_vertical from "../animations/F2-phone-vertical.json";
import { useState } from "react";

interface Props {
  lang: Languages;
  headerNum: String;
  onClick: () => void;
}

function SelfieFaceOnly({lang, headerNum, onClick}: Props) {
  const [checkTerms, setCheckTerms] = useState<Check>(Check.UNCHECKED);

  const handleCheckTerms = () => {
    if(checkTerms === Check.CHECKED)
      setCheckTerms(Check.UNCHECKED);
    else
      setCheckTerms(Check.CHECKED);
  }

  const handleClick = () => {
    if(checkTerms !== Check.CHECKED){
      setCheckTerms(Check.EMPHASIZED);
      const element = document.getElementById("checkTermsSpacer");
      if(element)
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      return;
    }

    onClick();
  }

  const onLink = () => {}

  return (
    <>
    <div className={uni.container}>
      {header(getLang(LangIds.SELFIE_Header, lang), headerNum)}
      <div className={uni.innerSmallCenterContainer}>
        <div className={uni.spacer}/>
        <div className={uni.bigText}>{getLang(LangIds.SELFIE_Name, lang)}</div>
        <div className={uni.spacerSmall}/>
        <div className={uni.mediumText}><b>{getLang(LangIds.SELFIE_Desc1, lang)}</b>{getLang(LangIds.SELFIE_Desc2, lang)}</div>
        <div className={uni.spacerBig}/>
        <div className={uni.center}>
          <Lottie className={uni.animationContainer} animationData={lottie_vertical}/>
        </div>
        <div className={uni.spacerBig}/>
        <div className={uni.checkboxContainer} onClick={handleCheckTerms}>
        {checkbox(checkTerms)}
        <div className={uni.smallText}>
          {getLang(LangIds.SELFIE_Terms1, lang)}
          <a href="https://trucrowd.tech/prednaska24pay/EUBA_GDPR.pdf">{getLang(LangIds.SELFIE_Terms2, lang)}</a>
          .
        </div>
      </div>
      {error(checkTerms===Check.EMPHASIZED, getLang(LangIds.ACCEPT_ErrAccept, lang))}
      </div>
      <div className={uni.filler} id='checkTermsSpacer'/>
      <div className={uni.innerSmallCenterContainer}>
        <button className={uni.button} type="button" onClick={handleClick}>{getLang(LangIds.SELFIE_Take, lang)}</button>
        {logo(getLang(LangIds.LOGO_Powered, lang))}
      </div>
    </div>
    </>
  );
}

export default SelfieFaceOnly;
